import { ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import {Common} from "../../core/constants/common";

export class LoginBase {
  validUsernameFormat = true;
  validPasswordFormat = true;
  emailPattern = Common.EMAIL_PATTERN;
  isEnLanguage = true;
  @ViewChild('f', { static: false }) ngForm: NgForm;

  private resetError() {
    if (!this.validUsernameFormat || !this.validPasswordFormat) {
      // set all fields has error, this is weird but issue 4119 requires this
      this.ngForm.form.controls.name.setErrors({ incorrect: true });
      this.ngForm.form.controls.pass.setErrors({ incorrect: true });
    } else {
      // clear error all
      this.ngForm.form.controls.name.setErrors(null);
      this.ngForm.form.controls.pass.setErrors(null);
    }
  }

  usernameChanged(username: string) {
    const trimmedUsername = username.trim();
    if (trimmedUsername !== '') {
      const m = /^[\x21-\x7E]+$/g.test(trimmedUsername);
      this.validUsernameFormat = m;
    } else {
      this.validUsernameFormat = true;
    }
    this.resetError();
  }

  passwordChanged(password: string) {
    if (password !== '') {
      const m = /^[\x20-\x7E]+$/g.test(password);
      this.validPasswordFormat = m;
    } else {
      this.validPasswordFormat = true;
    }
    this.resetError();
  }
  setLanguagelocalStored(newLanguge: string) {
    localStorage.setItem('__language', newLanguge);
  }

  getLanguagelocalStored() {
    return localStorage.getItem('__language');
  }

  checkIconLanguage(language: string) {
    if (language === 'en') {
      this.isEnLanguage = true;
    } else {
      this.isEnLanguage = false;
    }
  }
}
